import { render, staticRenderFns } from "./ScaleType.vue?vue&type=template&id=56927792"
import script from "./ScaleType.vue?vue&type=script&lang=js"
export * from "./ScaleType.vue?vue&type=script&lang=js"
import style0 from "./ScaleType.vue?vue&type=style&index=0&id=56927792&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports